import { IdcardOutlined } from '@ant-design/icons';
import { AnagraficaDelegatoDTO } from '@framework/api-client';
import { t } from '@framework/i18n';
import { Button, Tooltip } from 'antd';
import React, { useState } from 'react';
import { AddressBookModal } from './AddressBookModal';

export type IAddressBookSelectInputOnSelect = (
  record: AnagraficaDelegatoDTO,
  close: () => void,
  setValue: (record: unknown | ((v: unknown) => unknown)) => void,
) => void;

export interface IAddressBookButtonProps {
  /** Campo CF/Email da impostare */
  idFieldName: string;
  onSelect: IAddressBookSelectInputOnSelect;
  selected?: string[];
}

/**
 * Pulsante che mostra la lista dei delegati registrati in rubrica. Una volta
 * selezionati, il valore viene restituito e impostato in altri campi del form.
 */
export default function AddressBookButton(props: IAddressBookButtonProps) {
  const { onSelect, idFieldName, selected } = props;

  const [modalOpen, setModalOpen] = useState(false);

  const buttonText = t('address-book.button.apri-rubrica', 'Apri rubrica');

  return (
    <>
      <Tooltip title={buttonText}>
        <Button
          aria-label={buttonText}
          type="primary"
          icon={<IdcardOutlined aria-hidden="true" />}
          onClick={() => {
            setModalOpen(true);
          }}
        />
      </Tooltip>
      <AddressBookModal
        isOpen={modalOpen}
        setIsOpen={setModalOpen}
        idFieldName={idFieldName}
        onSelect={onSelect}
        selected={selected}
      />
    </>
  );
}
